/** A successful HTTP response alone is not a saved applicant declaration. */
export function isEmploymentConfirmationReceiptCurrent(receipt) {
  if (!receipt || receipt.confirmation_current !== true) return false;
  return ['awaiting_admin_review', 'approved'].includes(
    String(receipt.state || '').toLowerCase()
  );
}
